<template>
  <div v-if="events.length > 0" class="ds-events">
    <dl class="dl mts">
      <template v-for="(event, idx) in events" :key="'dt-' + idx">
        <dt class="dt">{{ event.name }}</dt>
        <dd class="dd" v-html="event.desc"></dd>
      </template>
    </dl>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { EventDoc, GlueDocs } from "./glue-documentation-types";

@Component({ name: "event-docs" })
export default class GlueDocEvents extends Vue {
  @Prop(String)
  public readonly componentName!: string;

  get events(): EventDoc[] {
    const doc: GlueDocs = window[this.componentName + "-docs"];
    if (doc != null) {
      if (doc.events) {
        return doc.events;
      }
    }
    return [];
  }
}
</script>
